import { render, staticRenderFns } from "./TradePost.vue?vue&type=template&id=6fae09a4&lang=pug&"
import script from "./TradePost.vue?vue&type=script&lang=js&"
export * from "./TradePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports